var communityProfileGroupsConfig = [
    {
        id: 'changeProfilePhoto-group',
        value: 'changeProfilePhoto-group',
        settingsGroupParams: [
            {
                id: 'changeCommunityProfilePhotoGroupParams',
                values: [
                    {
                        id: 'profilePhoto',
                        value: 'profilePhoto',
                        title: 'Фото сообщества',
                        type: 'photo-upload',
                        dependentFields: ['name']
                    },
                ],
                type: 'accordion'
            },
        ]
    },
    {
        id: 'id-group',
        value: 'id-group',
        title: 'ID',
        settingsGroupParams: [
            {
                id: 'id-group',
                values: [
                    {
                        id: 'id',
                        value: 'id',
                        title: 'ID',
                        type: 'textField'
                    },
                ],
                type: 'accordion',
                editable: false
            },
        ]
    },
    {
        id: 'name-group',
        value: 'name-group',
        title: 'Название',
        settingsGroupParams: [
            {
                id: 'nameGroupParams',
                values: [
                    {
                        id: 'name',
                        value: 'name',
                        title: 'Название',
                        type: 'textField'
                    },
                ],
                type: 'accordion',
                editable: true
            },
        ]
    },
    {
        id: 'description-Community',
        value: 'description-Community',
        title: 'Информация',
        settingsGroupParams: [
            {
                id: 'descriptionCommunityGroupParams',
                values: [
                    {
                        id: 'description',
                        value: 'description',
                        title: 'Информация',
                        type: 'textEditor',
                        textFieldIsMultiline: true
                    },
                ],
                type: 'accordion',
                editable: true
            },
        ]
    },
    {
        id: 'url-Community',
        value: 'url-Community',
        title: 'Уникальное имя для URL',
        settingsGroupParams: [
            {
                id: 'urlCommunityGroupParams',
                values: [
                    {
                        id: 'url',
                        value: 'url',
                        title: 'Уникальное имя',
                        type: 'textField',
                        textFieldIsMultiline: false
                    },
                ],
                type: 'accordion',
                editable: true
            },
        ]
    },
];
export default communityProfileGroupsConfig;
